import { gql } from '@apollo/client'

export const GET_FARE_FAMILIES = gql`
  query GetFareFamilies($input: fareFamiliesInput) {
    fareFamilies(input: $input) {
      id
      company {
        id
        name
      }
      segment {
        id
        origin {
          id
          code
        }
        destination {
          id
          code
        }
      }
      familyName
      fares {
        id
        bookingClass {
          id
          name
        }
        seasonType
        serviceType
        type
        timeWindow
        dow
        demand
        salesChannel
        basePrice
        isActive
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_FARE_FAMILIES_WITH_PAGINATION = gql`
  query GetFareFamiliesWithPagination($pagination: Pagination, $input: fareFamiliesInput) {
    fareFamiliesWithPagination(pagination: $pagination, input: $input) {
      total
      items {
        id
        company {
          id
          name
        }
        segment {
          id
          origin {
            id
            code
          }
          destination {
            id
            code
          }
        }
        familyName
        fares {
          id
          bookingClass {
            id
            name
          }
          seasonType
          serviceType
          type
          timeWindow
          dow
          demand
          salesChannel
          basePrice
          isActive
          createdAt
          updatedAt
        }
      }
    }
  }
`
